/**
 * Responsibility: Implement audit log behavior for the engine layer.
 * Scope: Owns engine-layer concerns only; cross-layer orchestration is excluded.
 */
import type { SupervisorIncident, SupervisorRunSummary } from "@anyquest/shared-core"

const MAX_AUDIT_LOG_SIZE = 500

class AuditLog {
  private runs: SupervisorRunSummary[] = []
  private incidents: SupervisorIncident[] = []

  recordRun(summary: SupervisorRunSummary) {
    this.runs.push(summary)
    if (this.runs.length > MAX_AUDIT_LOG_SIZE) {
      this.runs.shift()
    }
  }

  recordIncident(incident: SupervisorIncident) {
    this.incidents.push(incident)
    if (this.incidents.length > MAX_AUDIT_LOG_SIZE * 2) {
      this.incidents.shift()
    }
  }

  updateIncidentStatus(incidentId: string, status: SupervisorIncident['remediationStatus']) {
    const inc = this.incidents.find(i => i.id === incidentId)
    if (inc) inc.remediationStatus = status
  }

  getIncidents(): SupervisorIncident[] {
    return [...this.incidents]
  }

  getIncidentById(incidentId: string): SupervisorIncident | undefined {
    return this.incidents.find(i => i.id === incidentId)
  }

  getRuns(): SupervisorRunSummary[] {
    return [...this.runs]
  }

  clear() {
    this.runs = []
    this.incidents = []
  }
}

export const auditLog = new AuditLog()
